import { useEffect } from "react";

/**
 * Ouvre un champ du formulaire au montage (ex : rouvrir le moteur avec la cabine active,
 * depuis un lien externe). Le champ cible doit exposer `.focus()` (react-select) ou `.open()`
 * (drawer mobile) sur son ref.
 *
 * @param {object} selectRefs - Map { fieldId → ref } des champs.
 * @param {string} [initialFocusField] - Id du champ à ouvrir au montage.
 */
const useInitialFocusField = (selectRefs, initialFocusField) => {
	useEffect(() => {
		const field = initialFocusField && selectRefs[initialFocusField]?.current;

		if (!field) {
			return;
		}

		if (typeof field.open === "function") {
			field.open();
		} else if (typeof field.focus === "function") {
			field.focus();
		}
	}, [initialFocusField, selectRefs]);
};

export default useInitialFocusField;
